import React from "react";
import { CCard, CCardBody, CSpinner } from "@coreui/react";

const WelcomeCard = ({ admin, navigate }) => {
  return (
    <CCard className="border-light">
      <CCardBody>
        <span className="" style={{ color: "var(--ansa-dash-blue)", fontWeight: "bold" }}>Welcome back!</span>
        <h5 className="text-muted">
          <small>
            {admin.username && admin.role ? (
              <>
                {admin.username} ({admin.role})
              </>
            ) : (
              <CSpinner color="primary" />
            )}
          </small>
        </h5>
        <div className="d-flex justify-content-start">
          <button
            type="button"
            className="btn ansa-dash-button-primary m-3"
            onClick={() => navigate(`/dashboard/profile`)}
          >
            View Profile
          </button>
        </div>
      </CCardBody>
    </CCard>
  );
};

export default WelcomeCard;
